import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../web/components-v2/Theme/theme';
import { CssSelectors } from '../../../web/styles/styles';

const { spacing, colors, typography } = THEME;

export const styleSheet = StyleSheet.create({
	emailInput: {
		marginBottom: spacing.md,
	},
	header: {
		position: 'relative',
		display: 'flex',
		justifyContent: 'flex-end',
	},
	closeButton: {
		padding: '0 !important',
		marginBottom: THEME.spacing.md,
	},
	paymentInfoTitle: {
		color: colors.text.main,
		margin: `0 0 ${spacing.md}px`,
		fontSize: typography.fontSizes.lg,
		fontWeight: typography.fontWeights.bold,
	},
	orderInfo: {
		color: colors.text.main,
		display: 'flex',
		flexDirection: 'column',
		gap: spacing.xs,
		...CssSelectors.allDescendants(
			{
				color: colors.text.main,
				margin: 0,
				fontSize: typography.fontSizes.sm,
			},
			'p'
		),
		...CssSelectors.allDescendants(
			{
				color: colors.text.main,
				fontWeight: typography.fontWeights.bold,
			},
			'strong'
		),
	},
	timesSymbol: {
		color: colors.text.main,
		fontSize: typography.fontSizes.md,
	},
	label: {
		color: colors.text.main,
		display: 'block',
		fontSize: typography.fontSizes.sm,
		margin: `0 0 ${spacing.xs}px`,
		textAlign: 'left',
		fontWeight: typography.fontWeights.bold,
	},
	submitButton: {
		marginTop: spacing.md,
	},
	errorMessage: {
		color: colors.danger.main,
		fontSize: typography.fontSizes.sm,
		marginTop: spacing.sm,
		display: 'block',
		textAlign: 'center',
	},
	formContainer: {
		maxHeight: '80vh',
		overflowX: 'auto',
	},
});
